import { render } from "./ModalConfirmation.vue?vue&type=template&id=3abd88c0&scoped=true&ts=true"
import script from "./ModalConfirmation.vue?vue&type=script&lang=ts"
export * from "./ModalConfirmation.vue?vue&type=script&lang=ts"

import "./ModalConfirmation.vue?vue&type=style&index=0&id=3abd88c0&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3abd88c0"]])

export default __exports__